// Bileli · modules/media/model — media-upload DOMAIN types (G2). Hand-mirrored from the backend
// UploadTicket/MediaAsset (the fork has no OpenAPI codegen). Protocol is fixed by kind: PDF→S3_PUT (R2/
// MinIO), IMAGE→CF_DIRECT_FORM (Cloudflare Images), VIDEO→BUNNY_TUS (Bunny). Slice 1 implements S3_PUT (PDF).

export type MediaKind = 'PDF' | 'IMAGE' | 'VIDEO';

export interface MediaAsset {
  id: string; // the mediaId — stable from initiate through finalize
  kind?: MediaKind;
  state?: 'PENDING' | 'READY' | 'FAILED';
  contentType?: string;
}

interface BaseTicket {
  asset: MediaAsset;
  uploadExpiresInSec?: number;
}
export interface S3PutTicket extends BaseTicket { protocol: 'S3_PUT'; uploadUrl: string }
export interface CfDirectFormTicket extends BaseTicket { protocol: 'CF_DIRECT_FORM'; uploadUrl: string }
export interface BunnyTusTicket extends BaseTicket {
  protocol: 'BUNNY_TUS';
  creationUrl: string;
  tusVersion: string;
  libraryId: number;
  videoGuid: string;
  authorizationSignature: string;
  authorizationExpire: number; // unix seconds
  uploadMetadataBase64: string;
}
export type UploadTicket = S3PutTicket | CfDirectFormTicket | BunnyTusTicket;

// Allow-lists + caps mirror the backend (MediaService content-type check + application.conf caps).
export const MEDIA_CONTENT_TYPES: Record<MediaKind, string[]> = {
  PDF: ['application/pdf'],
  IMAGE: ['image/jpeg', 'image/png', 'image/webp'],
  VIDEO: ['video/mp4', 'video/quicktime', 'video/webm', 'video/x-matroska'],
};
export const MEDIA_MAX_BYTES: Record<MediaKind, number> = {
  PDF: 52_428_800, // 50 MB
  IMAGE: 10_485_760, // 10 MB
  VIDEO: 5_368_709_120, // 5 GB
};
export const MEDIA_ACCEPT: Record<MediaKind, string> = {
  PDF: 'application/pdf,.pdf',
  IMAGE: 'image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp',
  VIDEO: 'video/mp4,video/quicktime,video/webm',
};
